import { env } from '../constants/env';

export const allowNewSubscriptions = (): boolean => {
  return env.NEXT_PUBLIC_ALLOW_NEW_SUBSCRIPTIONS === 'true';
};